/** Identifiant de mesure Google Analytics (gtag). */
export const GA_MEASUREMENT_ID: string = 'G-MXXQ29RJ5H'

/** Container Google Tag Manager. */
export const GTM_CONTAINER_ID: string = 'GTM-MZWB6KK'

/** URL du container Matomo Tag Manager. */
export const MATOMO_TAG_MANAGER_URL: string =
  'https://cdn.matomo.cloud/azurewebsites.matomo.cloud/container_Acid54WS.js'

/** Identifiant de site Hotjar. */
export const HOTJAR_SITE_ID: number = 2903227

/** Version du script Hotjar (`hjsv`). */
export const HOTJAR_SCRIPT_VERSION: number = 6

/** Clé `localStorage` pour la décision du bandeau cookies analytics. */
export const ANALYTICS_CONSENT_STORAGE_KEY: string = 'prepeers_cookie_consent'
